export class ProductBatchItemFromFileUpdateStockPercentualModel {
	skuCode?: string|number|null = null;
	codeSource?: string|number|null = null;
	stockPercentage: string|number|null = null;

	constructor(p?: Partial<ProductBatchItemFromFileUpdateStockPercentualModel>) {
		Object.assign(this, p)
	}
}
